import { IJSLComponent, IJSLVNode, refresh } from "jsl-render";
import { PublicController } from "../../ajax/PublicController";

export class UserNameComponent implements IJSLComponent {

    private static userList: any;

    private displayName: string;

    public constructor(login: string) {
        if (UserNameComponent.userList == null) {
            PublicController.GetUsers().then((x) => {
                UserNameComponent.userList = x;
                this.displayName = UserNameComponent.userList[login] ?? login;
                refresh();
            });
        } else {
            this.displayName = UserNameComponent.userList[login] ?? login;
        }
    }

    public render(): IJSLVNode {
        return {tag: "span", content: this.displayName};
    }

    public isEqual(node: IJSLComponent): boolean {
        return (this as any).__proto__ === (node as any).__proto__;
    }
}
